import { render } from "./tab-learn-word-new.vue?vue&type=template&id=b853d842&scoped=true"
import script from "./tab-learn-word-new.vue?vue&type=script&lang=js"
export * from "./tab-learn-word-new.vue?vue&type=script&lang=js"

import "./tab-learn-word-new.vue?vue&type=style&index=0&id=b853d842&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b853d842"]])

export default __exports__